import React from "react";

export const GameActionSection = ({ not_enough_keys_warning_text, submit_btn }) => {
    return (
        <React.Fragment>
            {not_enough_keys_warning_text}
            {submit_btn}
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/c/GameActionSection.js